//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { InsurStore, InsurMutations } from "../../store";
import { elementType, format } from "@/views/stencil/common/config";
import FromItem from "@/components/common/from/fromItem";
import InTitle from "@/views/stencil/components/title";
import PayMethods from "./payMethods";
import fromInput from "@/views/stencil/components/from/fromInput.vue";
import fromTab from "@/views/stencil/components/from/fromTab";
import fromCheck from "@/views/stencil/components/from/fromCheck";
import mixinVerify from "@/utils/mixin/mixinVerify";

export default {
	mixins: [mixinVerify],
	data() {
		return {
			data: {},
		};
	},
	components: {
		elementInput: fromInput,
		elementRadio: fromTab,
		elementCheck: fromCheck,
		InTitle,
		FromItem,
		PayMethods,
	},
	computed: {
		// 投被保人model
		modules() {
			return InsurStore.insuranceform.modules;
		},
		// 禁用字段
		forbidElements(){
			return InsurStore.insuranceform.forbidElements;
		},
		// 附加服务协议
		additionalServices() {
			return InsurStore.insuranceform.schemes[0].addServices;
		},
		// 附加服务协议价格
		additionItems() {
			if (InsurStore.insuranceform.costRateInfo) {
				return InsurStore.insuranceform.costRateInfo.additionItems || [];
			}
			return [];
		},
		// 缴费方式
		payMethod() {
			return InsurStore.insuranceform.payMethod;
		},
		// 缴费方式下的缴费列表
		premiumList() {
			return InsurStore.resultCount.premiumList;
		},
		// 商品code
		productCode() {
			return InsurStore.insuranceform.productCode;
		},
		//投被保人关系
		relationship() {
			return InsurStore.relationship;
		},
	},
	watch: {
		data: {
			deep: true,
			handler: (newValue, oldValue) => {
				InsurStore.fromPageData = newValue;
				console.log("data", newValue);
			},
		},
		// 根据被保人关系 修改为谁投保模块内 组件是否必填
		relationship(newValue, oldValue) {
			console.log("关系newValue：", newValue);
			this.$nextTick(() => {
				Object.keys(this.data).forEach((key) => {
					// 被保人 && 输入框
					if (
						this.data[key].moduleCode == "BBRXX001" &&
						this.data[key].componentTypeCode == "WBK001"
					) {
						// 为本人时改为非必填
						if (newValue == "1") {
							let item = this.data[key];
							item.isRequired = false;
						} else {
							// 其他关系时 是否必填改回默认值
							let item = this.data[key];
							item.isRequired = item.defaultisRequired;
							item.value = "";
						}
					}
				});
			});
			// console.log('data', this.data)
		},
	},
	created() {},
	methods: {
		//
		TypeCode(code) {
			return elementType[code] || "elementInput";
		},
		// 得到的参数格式化
		setElement(element, code) {
			return format(element, code);
		},
		// 数据手动修改时
		itemChange(item) {
			this.$nextTick(() => {
				// 如果是算费因子去取请求算费结果
				if (item.isCount) {
					// console.log('去取请求算费结果',item);
					this.$nextTick(() => {
						// 调用公共方法请求算费
						this.getRateResult(this.data, this.productCode).then((res) => {
							// 格式化算费
							InsurMutations.resultCountReset(res);
						});
					});

					// 当选选中本人
				} else if (this.relationship == 1) {
					let bb_idcard = this.data["INSURED_CARD_CODE"];
					let my_idcard = this.data["BUYER_CARD_CODE"];
					if (bb_idcard && my_idcard) {
						if (bb_idcard.value === my_idcard.value) {
							return false;
						} else {
							// 把本人身份证赋值给被保人身份证
							bb_idcard.value = my_idcard.value;
							// 调用公共方法请求算费
							this.getRateResult(this.data, this.productCode).then((res) => {
								// 格式化算费
								InsurMutations.resultCountReset(res);
							});
						}
					}
				}
			});
		},
	},
};
